import { render, staticRenderFns } from "./ListadoConsultas.vue?vue&type=template&id=d2c72f08&scoped=true"
import script from "./ListadoConsultas.vue?vue&type=script&lang=js"
export * from "./ListadoConsultas.vue?vue&type=script&lang=js"
import style0 from "./ListadoConsultas.vue?vue&type=style&index=0&id=d2c72f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c72f08",
  null
  
)

export default component.exports